/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { StakedPerpToken } from "./StakedPerpToken";

export class StakedPerpTokenFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<StakedPerpToken> {
    return super.deploy(overrides || {}) as Promise<StakedPerpToken>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): StakedPerpToken {
    return super.attach(address) as StakedPerpToken;
  }
  connect(signer: Signer): StakedPerpTokenFactory {
    return super.connect(signer) as StakedPerpTokenFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): StakedPerpToken {
    return new Contract(address, _abi, signerOrProvider) as StakedPerpToken;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "stakedModule",
        type: "address",
      },
    ],
    name: "StakeModuleAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "stakedModule",
        type: "address",
      },
    ],
    name: "StakeModuleRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Staked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Unstaked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Withdrawn",
    type: "event",
  },
  {
    inputs: [],
    name: "TOKEN_AMOUNT_LIMIT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IStakeModule",
        name: "_stakeModule",
        type: "address",
      },
    ],
    name: "addStakeModule",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "__blockNumber",
        type: "uint256",
      },
    ],
    name: "balanceOfAt",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "candidate",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "cooldownPeriod",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getStakeModuleLength",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "_perpToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_cooldownPeriod",
        type: "uint256",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IStakeModule",
        name: "_stakeModule",
        type: "address",
      },
    ],
    name: "isStakeModuleExisted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "perpToken",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IStakeModule",
        name: "_stakeModule",
        type: "address",
      },
    ],
    name: "removeStakeModule",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_amount",
        type: "tuple",
      },
    ],
    name: "stake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "stakeModules",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "stakerCooldown",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "stakerWithdrawPendingBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "d",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "__blockNumber",
        type: "uint256",
      },
    ],
    name: "totalSupplyAt",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unstake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "updateOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x608060405234801561001057600080fd5b50612c80806100206000396000f3fe608060405234801561001057600080fd5b50600436106101da5760003560e01c80638da5cb5b11610104578063bc5920ba116100a2578063dd62ed3e11610071578063dd62ed3e1461038a578063de1141901461039d578063f0a10b1a146103a5578063fae7d15c146103b8576101da565b8063bc5920ba14610349578063c1bbe0de14610351578063cd6dc68714610364578063d5f8fcfa14610377576101da565b8063981b24d0116100de578063981b24d0146103085780639cadb3a01461031b578063a9059cbb14610323578063ac04f24314610336576101da565b80638da5cb5b146102e557806390c95b7d146102ed57806395d89b4114610300576101da565b806329a2293d1161017c5780634ee2cd7e1161014b5780634ee2cd7e146102a25780636c8381f8146102b557806370a08231146102ca578063715018a6146102dd576101da565b806329a2293d1461026a5780632def66201461027d578063313ce567146102855780633ccfd60b1461029a576101da565b8063095ea7b3116101b8578063095ea7b31461021a57806313af40351461023a57806318160ddd1461024f57806323b872dd14610257576101da565b8063032370dc146101df57806304646a49146101fd57806306fdde0314610205575b600080fd5b6101e76103cb565b6040516101f49190612bf2565b60405180910390f35b6101e76103d3565b61020d6103da565b6040516101f49190612593565b61022d61022836600461244c565b610468565b6040516101f49190612588565b61024d6102483660046123b8565b61048b565b005b6101e7610564565b61022d61026536600461240c565b610583565b6101e76102783660046123b8565b61059d565b61024d6105b0565b61028d610789565b6040516101f49190612bfb565b61024d610793565b6101e76102b036600461244c565b61087e565b6102bd610896565b6040516101f49190612537565b6101e76102d83660046123b8565b6108a5565b61024d6108c3565b6102bd610942565b6101e76102fb3660046123b8565b610951565b61020d610964565b6101e76103163660046124eb565b6109bf565b6102bd6109cd565b61022d61033136600461244c565b6109dd565b61024d610344366004612497565b6109f7565b61024d610be3565b6102bd61035f3660046124eb565b610ca6565b61024d61037236600461244c565b610cce565b61022d6103853660046123b8565b610e18565b6101e76103983660046123d4565b610e88565b6101e7610e90565b61024d6103b33660046123b8565b610e95565b61024d6103c63660046123b8565b610f66565b610105545b90565b6101075481565b60fe805460408051602060026001851615610100026000190190941693909304601f810184900484028201840190925281815292918301828280156104605780601f1061043557610100808354040283529160200191610460565b820191906000526020600020905b81548152906001019060200180831161044357829003601f168201915b505050505081565b600060405162461bcd60e51b81526004016104829061293d565b60405180910390fd5b610493611026565b6098546001600160a01b039081169116146104c05760405162461bcd60e51b815260040161048290612af1565b6001600160a01b0381166104e65760405162461bcd60e51b8152600401610482906128ad565b6098546001600160a01b03828116911614156105145760405162461bcd60e51b815260040161048290612b75565b6099546001600160a01b03828116911614156105425760405162461bcd60e51b815260040161048290612693565b609980546001600160a01b0319166001600160a01b0392909216919091179055565b600061057e61057961057461102a565b61102e565b611064565b905090565b600060405162461bcd60e51b815260040161048290612634565b6101036020526000908152604090205481565b60006105ba611026565b90506105c4611068565b6001600160a01b038116600090815261010460209081526040918290208251918201909252905481526105f690611064565b156106135760405162461bcd60e51b815260040161048290612758565b61061b61230d565b60405180602001604052806106546101026000866001600160a01b03166001600160a01b0316815260200190815260200160002061108a565b90529050610661816110d5565b61066b8282611100565b6106866101075461067a61120e565b9063ffffffff61121216565b6001600160a01b038316600090815261010360209081526040808320939093556101049052908120825190555b610105548110156107435761010581815481106106cc57fe5b60009182526020909120015460405163cd8ae3dd60e01b81526001600160a01b039091169063cd8ae3dd90610705908690600401612537565b600060405180830381600087803b15801561071f57600080fd5b505af1158015610733573d6000803e3d6000fd5b5050600190920191506106b39050565b507f0f5bb82176feb1b5e747e28471aa92156a04d9f3ab9f45f28e2d704232b93f758261076f83611064565b60405161077d92919061256f565b60405180910390a15050565b6101005460ff1681565b600061079d611026565b90506107a761230d565b506001600160a01b038116600090815261010460209081526040918290208251918201909252905481526107da816110d5565b6001600160a01b038216600090815261010360205260409020546107fc61120e565b101561081a5760405162461bcd60e51b815260040161048290612882565b6001600160a01b038083166000908152610104602090815260408083208390556101039091528120556101065461085391168383611237565b7f7084f5476618d8e60b11ef0d7d3f06914655adb8793e28ff7f018d4c76d505d58261076f83611064565b600061088d6105798484611366565b90505b92915050565b6099546001600160a01b031690565b60006108bb610579836108b661102a565b611366565b90505b919050565b6108cb611026565b6098546001600160a01b039081169116146108f85760405162461bcd60e51b815260040161048290612af1565b6098546040516000916001600160a01b0316907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0908390a3609880546001600160a01b0319169055565b6098546001600160a01b031690565b6101046020526000908152604090205481565b60ff805460408051602060026001851615610100026000190190941693909304601f810184900484028201840190925281815292918301828280156104605780601f1061043557610100808354040283529160200191610460565b60006108bb6105798361102e565b610106546001600160a01b031681565b600060405162461bcd60e51b815260040161048290612a02565b610a0e610a09368390038301836124ae565b6110d5565b610a16611068565b6000610a20611026565b9050610a2a61230d565b610a39368490038401846124ae565b6001600160a01b03831660009081526101046020908152604091829020825191820190925290548152909150610a6e90611064565b15610ad8576001600160a01b03821660009081526101046020908152604091829020825191820190925290548152610aad90829063ffffffff6113b316565b6001600160a01b03831660009081526101046020908152604080832083905561010390915281205590505b61010654610aff906001600160a01b03168330610afa368890038801886124ae565b6113df565b610b098282611511565b60005b61010554811015610b9c576101058181548110610b2557fe5b60009182526020909120015460405163cd8ae3dd60e01b81526001600160a01b039091169063cd8ae3dd90610b5e908690600401612537565b600060405180830381600087803b158015610b7857600080fd5b505af1158015610b8c573d6000803e3d6000fd5b505060019092019150610b0c9050565b507f9e71bc8eea02a63969f509818f2dafb9254532904319f9dbda79b67bd34a5f3d82610bc883611064565b604051610bd692919061256f565b60405180910390a1505050565b6099546001600160a01b0316610c0b5760405162461bcd60e51b815260040161048290612aa2565b610c13611026565b6099546001600160a01b03908116911614610c405760405162461bcd60e51b8152600401610482906126da565b6099546098546040516001600160a01b0392831692909116907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a360998054609880546001600160a01b03199081166001600160a01b03841617909155169055565b6101058181548110610cb457fe5b6000918252602090912001546001600160a01b0316905081565b603354610100900460ff1680610ce75750610ce7611601565b80610cf5575060335460ff16155b610d115760405162461bcd60e51b8152600401610482906128ef565b603354610100900460ff16158015610d3c576033805460ff1961ff0019909116610100171660011790555b6001600160a01b038316610d625760405162461bcd60e51b81526004016104829061266b565b610d6a611607565b6040805180820190915260108082526f14dd185ad9590814195c9c195d1d585b60821b6020909201918252610da19160fe91612320565b5060408051808201909152600580825264073504552560dc1b6020909201918252610dce9160ff91612320565b50610100805460ff1916601217905561010680546001600160a01b0385166001600160a01b03199091161790556101078290558015610e13576033805461ff00191690555b505050565b60006108bb82610105805480602002602001604051908101604052809291908181526020018280548015610e7557602002820191906000526020600020905b81546001600160a01b03168152600190910190602001808311610e57575b505050505061169990919063ffffffff16565b600092915050565b601481565b610e9d611026565b6098546001600160a01b03908116911614610eca5760405162461bcd60e51b815260040161048290612af1565b6000610ede6101058363ffffffff6116ef16565b90506001600160a01b038116610f065760405162461bcd60e51b815260040161048290612b3e565b816001600160a01b0316816001600160a01b031614610f375760405162461bcd60e51b81526004016104829061280a565b7f2c54da8cf6b6d65b4bd7e9bf095dd4d133a2ce5731ebb20a4f1bcc3db90294308260405161077d9190612537565b610f6e611026565b6098546001600160a01b03908116911614610f9b5760405162461bcd60e51b815260040161048290612af1565b61010554601411610fbe5760405162461bcd60e51b815260040161048290612721565b610fd06101058263ffffffff6117fb16565b610fec5760405162461bcd60e51b815260040161048290612a39565b7f9400eb2cfb16fdd3f18022e33f5d4b757dea0c4367d95f0495f6af5911e1e9148160405161101b9190612537565b60405180910390a150565b3390565b4390565b61103661230d565b604051806020016040528061105c61104d856118b4565b6101019063ffffffff61191316565b905292915050565b5190565b610105546110885760405162461bcd60e51b8152600401610482906129b5565b565b805460009080156110cc578260000160018203815481106110a757fe5b600091825260209091200154600160401b90046001600160c01b031691506108be9050565b50600092915050565b60006110e082611064565b116110fd5760405162461bcd60e51b8152600401610482906129dd565b50565b6001600160a01b0382166111265760405162461bcd60e51b815260040161048290612974565b61112e61230d565b6040518060200160405280611142856108a5565b9052905061114e61230d565b61115e828463ffffffff61191f16565b905061116861230d565b604051806020016040528061117b610564565b9052905061118761230d565b611197828663ffffffff61191f16565b905060006111a361102a565b90506111b0878286611942565b6111ba8183611985565b60006001600160a01b0388167fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef6111f089611064565b6040516111fd9190612bf2565b60405180910390a350505050505050565b4290565b60008282018381101561088d5760405162461bcd60e51b8152600401610482906125fd565b611240836119b1565b61124861230d565b61125284846119fb565b905060006112608584611a88565b905060006060866001600160a01b031663a9059cbb60e01b878560405160240161128b92919061256f565b60408051601f198184030181529181526020820180516001600160e01b03166001600160e01b03199094169390931790925290516112c9919061251b565b6000604051808303816000865af19150503d8060008114611306576040519150601f19603f3d011682016040523d82523d6000602084013e61130b565b606091505b50915091508180156113355750805115806113355750808060200190518101906113359190612477565b6113515760405162461bcd60e51b8152600401610482906125c6565b61135d87878587611b06565b50505050505050565b61136e61230d565b60405180602001604052806113aa611385856118b4565b6001600160a01b0387166000908152610102602052604090209063ffffffff61191316565b90529392505050565b6113bb61230d565b6113c361230d565b825184516113d69163ffffffff61121216565b81529392505050565b6113e8846119b1565b6113f061230d565b6113fa85846119fb565b905060006114088684611a88565b905060006060876001600160a01b03166323b872dd60e01b8888866040516024016114359392919061254b565b60408051601f198184030181529181526020820180516001600160e01b03166001600160e01b0319909416939093179092529051611473919061251b565b6000604051808303816000865af19150503d80600081146114b0576040519150601f19603f3d011682016040523d82523d6000602084013e6114b5565b606091505b50915091508180156114df5750805115806114df5750808060200190518101906114df9190612477565b6114fb5760405162461bcd60e51b8152600401610482906127c9565b61150788878587611b06565b5050505050505050565b6001600160a01b0382166115375760405162461bcd60e51b815260040161048290612bbb565b61153f61230d565b6040518060200160405280611553856108a5565b9052905061155f61230d565b61156f828463ffffffff6113b316565b905061157961230d565b604051806020016040528061158c610564565b9052905061159861230d565b6115a8828663ffffffff6113b316565b905060006115b461102a565b90506115c1878286611942565b6115cb8183611985565b6001600160a01b03871660007fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef6111f089611064565b303b1590565b603354610100900460ff16806116205750611620611601565b8061162e575060335460ff16155b61164a5760405162461bcd60e51b8152600401610482906128ef565b603354610100900460ff16158015611675576033805460ff1961ff0019909116610100171660011790555b61167d611b5f565b611685611be0565b80156110fd576033805461ff001916905550565b6000805b83518110156116e5578381815181106116b257fe5b60200260200101516001600160a01b0316836001600160a01b031614156116dd576001915050610890565b60010161169d565b5060009392505050565b60006001600160a01b03821661170757506000610890565b825460005b818110156117f05784818154811061172057fe5b6000918252602090912001546001600160a01b03858116911614156117e8576001820381146117b15784600183038154811061175857fe5b9060005260206000200160009054906101000a90046001600160a01b031685828154811061178257fe5b9060005260206000200160006101000a8154816001600160a01b0302191690836001600160a01b031602179055505b848054806117bb57fe5b600082815260209020810160001990810180546001600160a01b0319169055019055508291506108909050565b60010161170c565b506000949350505050565b60006001600160a01b038216158061187157506118718380548060200260200160405190810160405280929190818152602001828054801561186657602002820191906000526020600020905b81546001600160a01b03168152600190910190602001808311611848575b505050505083611699565b1561187e57506000610890565b50815460018082018455600093845260209093200180546001600160a01b0319166001600160a01b039290921691909117905590565b60408051808201909152601581527455494e5436345f4e554d4245525f544f4f5f42494760581b602082015260009067ffffffffffffffff83111561190c5760405162461bcd60e51b81526004016104829190612593565b5090919050565b600061088d8383611cba565b61192761230d565b61192f61230d565b825184516113d69163ffffffff611e4b16565b610e1361194e836118b4565b61195f61195a84611064565b611e8d565b6001600160a01b038616600090815261010260205260409020919063ffffffff611ee516565b6119ad611991836118b4565b61199d61195a84611064565b610101919063ffffffff611ee516565b5050565b60006119bc82612087565b6001600160a01b03831660009081526020819052604090205490915081146119ad576001600160a01b0391909116600090815260208190526040902055565b611a0361230d565b61088d83846001600160a01b03166370a08231856040518263ffffffff1660e01b8152600401611a339190612537565b60206040518083038186803b158015611a4b57600080fd5b505afa158015611a5f573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611a839190612503565b612174565b600080611a9484612087565b905060128110611ad257611aca611ab282601263ffffffff611e4b16565b600a0a611abe85611064565b9063ffffffff61220616565b915050610890565b611afe611ae660128363ffffffff611e4b16565b600a0a611af285611064565b9063ffffffff61224016565b949350505050565b611b39611b23611b168685612174565b839063ffffffff6113b316565b611b2d86866119fb565b9063ffffffff61228216565b60000b15611b595760405162461bcd60e51b815260040161048290612a60565b50505050565b603354610100900460ff1680611b785750611b78611601565b80611b86575060335460ff16155b611ba25760405162461bcd60e51b8152600401610482906128ef565b603354610100900460ff16158015611685576033805460ff1961ff00199091166101001716600117905580156110fd576033805461ff001916905550565b603354610100900460ff1680611bf95750611bf9611601565b80611c07575060335460ff16155b611c235760405162461bcd60e51b8152600401610482906128ef565b603354610100900460ff16158015611c4e576033805460ff1961ff0019909116610100171660011790555b6000611c58611026565b609880546001600160a01b0319166001600160a01b038316908117909155604051919250906000907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0908290a35080156110fd576033805461ff001916905550565b815460009080611cce576000915050610890565b8354600019820190600090869083908110611ce557fe5b6000918252602090912001805490915067ffffffffffffffff90811690861610611d245754600160401b90046001600160c01b03169250610890915050565b8260011480611d5b575085600001600081548110611d3e57fe5b60009182526020909120015467ffffffffffffffff908116908616105b15611d6c5760009350505050610890565b600060001983015b81811115611e14578754600283830160010104906000908a9083908110611d9757fe5b6000918252602090912001805490915067ffffffffffffffff908116908a16811015611dc557829450611e0c565b8067ffffffffffffffff168a67ffffffffffffffff161015611dec57600183039350611e0c565b5054600160401b90046001600160c01b0316965061089095505050505050565b505050611d74565b876000018281548110611e2357fe5b600091825260209091200154600160401b90046001600160c01b031698975050505050505050565b600061088d83836040518060400160405280601e81526020017f536166654d6174683a207375627472616374696f6e206f766572666c6f7700008152506122aa565b60408051808201909152601681527555494e543139325f4e554d4245525f544f4f5f42494760501b60208201526000906001600160c01b0383111561190c5760405162461bcd60e51b81526004016104829190612593565b825480611f58576040805180820190915267ffffffffffffffff80851682526001600160c01b0380851660208085019182528854600181018a5560008a8152919091209451940180549151909216600160401b0293831667ffffffffffffffff1990911617909116919091179055611b59565b6000846000016001830381548110611f6c57fe5b6000918252602090912001805490915067ffffffffffffffff908116908516811015611ffe576040805180820190915267ffffffffffffffff80871682526001600160c01b0380871660208085019182528a54600181018c5560008c8152919091209451940180549151909216600160401b0293831667ffffffffffffffff199091161790911691909117905561207f565b808567ffffffffffffffff16141561203457815467ffffffffffffffff16600160401b6001600160c01b0386160217825561207f565b604080518082018252601a81527f434845434b504f494e545f504153545f434845434b504f494e540000000000006020820152905162461bcd60e51b81526104829190600401612593565b505050505050565b6001600160a01b038116600090815260208190526040812054806108bb5760408051600481526024810182526020810180516001600160e01b031663313ce56760e01b17905290516000916060916001600160a01b038716916120e99161251b565b600060405180830381855afa9150503d8060008114612124576040519150601f19603f3d011682016040523d82523d6000602084013e612129565b606091505b509150915081801561213b5750805115155b6121575760405162461bcd60e51b815260040161048290612788565b8080602001905181019061216b9190612503565b95945050505050565b61217c61230d565b600061218784612087565b9050601281106121cc576040805160208101909152806121c16121b184601263ffffffff611e4b16565b8690600a0a63ffffffff61224016565b815250915050610890565b6040805160208101909152806121fc6121ec60128563ffffffff611e4b16565b8690600a0a63ffffffff61220616565b9052949350505050565b60008261221557506000610890565b8282028284828161222257fe5b041461088d5760405162461bcd60e51b815260040161048290612841565b600061088d83836040518060400160405280601a81526020017f536166654d6174683a206469766973696f6e206279207a65726f0000000000008152506122d6565b80518251600091101561229757506001610890565b8151835110156110cc5750600019610890565b600081848411156122ce5760405162461bcd60e51b81526004016104829190612593565b505050900390565b600081836122f75760405162461bcd60e51b81526004016104829190612593565b50600083858161230357fe5b0495945050505050565b6040518060200160405280600081525090565b828054600181600116156101000203166002900490600052602060002090601f016020900481019282601f1061236157805160ff191683800117855561238e565b8280016001018555821561238e579182015b8281111561238e578251825591602001919060010190612373565b5061239a92915061239e565b5090565b6103d091905b8082111561239a57600081556001016123a4565b6000602082840312156123c9578081fd5b813561088d81612c35565b600080604083850312156123e6578081fd5b82356123f181612c35565b9150602083013561240181612c35565b809150509250929050565b600080600060608486031215612420578081fd5b833561242b81612c35565b9250602084013561243b81612c35565b929592945050506040919091013590565b6000806040838503121561245e578182fd5b823561246981612c35565b946020939093013593505050565b600060208284031215612488578081fd5b8151801515811461088d578182fd5b6000602082840312156124a8578081fd5b50919050565b6000602082840312156124bf578081fd5b6040516020810181811067ffffffffffffffff821117156124de578283fd5b6040529135825250919050565b6000602082840312156124fc578081fd5b5035919050565b600060208284031215612514578081fd5b5051919050565b6000825161252d818460208701612c09565b9190910192915050565b6001600160a01b0391909116815260200190565b6001600160a01b039384168152919092166020820152604081019190915260600190565b6001600160a01b03929092168252602082015260400190565b901515815260200190565b60006020825282518060208401526125b2816040850160208701612c09565b601f01601f19169190910160400192915050565b6020808252601d908201527f446563696d616c45524332303a207472616e73666572206661696c6564000000604082015260600190565b6020808252601b908201527f536166654d6174683a206164646974696f6e206f766572666c6f770000000000604082015260600190565b6020808252601f908201527f7472616e7366657246726f6d2829206973206e6f7420737570706f7274656400604082015260600190565b6020808252600e908201526d24b73b30b634b21034b7383aba1760911b604082015260600190565b60208082526027908201527f5065727046694f776e61626c65557067726164653a2073616d652061732063616040820152666e64696461746560c81b606082015260800190565b60208082526027908201527f5065727046694f776e61626c65557067726164653a206e6f7420746865206e656040820152663b9037bbb732b960c91b606082015260800190565b6020808252601f908201527f657863656564207374616b654d6f64756c6520616d6f756e74206c696d697400604082015260600190565b60208082526016908201527513995959081d1bc81dda5d1a191c985dc8199a5c9cdd60521b604082015260600190565b60208082526021908201527f446563696d616c45524332303a2067657420646563696d616c73206661696c656040820152601960fa1b606082015260800190565b60208082526021908201527f446563696d616c45524332303a207472616e7366657246726f6d206661696c656040820152601960fa1b606082015260800190565b60208082526018908201527f72656d6f76652077726f6e67207374616b654d6f64756c650000000000000000604082015260600190565b60208082526021908201527f536166654d6174683a206d756c7469706c69636174696f6e206f766572666c6f6040820152607760f81b606082015260800190565b60208082526011908201527029ba34b6361034b71031b7b7b63237bbb760791b604082015260600190565b60208082526022908201527f5065727046694f776e61626c65557067726164653a207a65726f206164647265604082015261737360f01b606082015260800190565b6020808252602e908201527f436f6e747261637420696e7374616e63652068617320616c726561647920626560408201526d195b881a5b9a5d1a585b1a5e995960921b606082015260800190565b6020808252601a908201527f617070726f76652829206973206e6f7420737570706f72746564000000000000604082015260600190565b60208082526021908201527f45524332303a206275726e2066726f6d20746865207a65726f206164647265736040820152607360f81b606082015260800190565b6020808252600e908201526d6e6f207374616b654d6f64756c6560901b604082015260600190565b6020808252600b908201526a0416d6f756e7420697320360ac1b604082015260600190565b6020808252601b908201527f7472616e736665722829206973206e6f7420737570706f727465640000000000604082015260600190565b6020808252600d908201526c1a5b9d985b1a59081a5b9c1d5d609a1b604082015260600190565b60208082526022908201527f446563696d616c45524332303a2062616c616e636520696e636f6e73697374656040820152611b9d60f21b606082015260800190565b6020808252602f908201527f5065727046694f776e61626c65557067726164653a2063616e6469646174652060408201526e6973207a65726f206164647265737360881b606082015260800190565b6020808252602d908201527f5065727046694f776e61626c65557067726164653a2063616c6c65722069732060408201526c3737ba103a34329037bbb732b960991b606082015260800190565b6020808252601a908201527f7374616b654d6f64756c6520646f6573206e6f74206578697374000000000000604082015260600190565b60208082526026908201527f5065727046694f776e61626c65557067726164653a2073616d65206173206f726040820152651a59da5b985b60d21b606082015260800190565b6020808252601f908201527f45524332303a206d696e7420746f20746865207a65726f206164647265737300604082015260600190565b90815260200190565b60ff91909116815260200190565b60005b83811015612c24578181015183820152602001612c0c565b83811115611b595750506000910152565b6001600160a01b03811681146110fd57600080fdfea264697066735822122073e989f64a15a254261493e3694f85ef06600b8e35def7f3d3554a88fb15f48b64736f6c63430006090033";
